module.exports = __webpack_public_path__ + "static/media/company--bg3-new.5dec7c27.jpg";